<template>
  <div class="developers w100">
    <div class="w60 m-auto p-top-50 p-btm-50 content">
    <p class="a98b59-color medium lt10 p-top-50 font18">THE ESTEEMED COLLECTION</p>
    <p class="a98b59-color light font40" style="margin-top: 0;">REDEFINING LUXURY FOR ECS AND BEYOND</p>
    <p class="w100 m-auto lh35 font18 medium">
      Launched as part of the inaugural Esteemed Collection, Novo Place is
      proudly brought to you by Hoi Hup Sunway, an award-winning collaboration
      between Hoi Hup Realty and Sunway Developments. Combining the expertise
      and experience of two real estate giants, this stellar partnership has
      inspired many successful projects such as The Continuum, Terra Hill, Ki
      Residences, Parc Central Residences EC and Parc Canberra EC.
    </p>
    <br />
    <p class="w100 m-auto lh35 font18 medium">
      The Continuum was named Best Premium Condo Development and Best Lifestyle
      Development 2023 at the PropertyGuru Asia Property Awards, as well as Top
      Development (Residential) and Landscape Excellence (Residential) at the
      EdgeProp Singapore Excellence Awards 2023.
      <br />
      Additionally, Terra Hill won Best Premium Condo Interior Design, Highly
      Commended Best Premium Condo Development and Highly Commended Best Nature
      Integrated Development at the PropertyGuru Asia Property Awards
      (Singapore) 2023, and Sustainability Excellence (Residential) at the
      EdgeProp Singapore Excellence Awards 2023.
    </p>
    <div class="w60 relative m-auto p-top-50 p-btm-50">
      <swiper
        class="swiper swiperDevTop bg-525c4e w100"
        style="height: 45vh"
        :options="swiperDevTop"
        ref="swiperDevTop"
      >
        <swiper-slide
          class="flex-center"
          v-for="(item, i) in devList"
          :key="i"
        >
          <div class="img-content w100 h100">
            <img :src="item.path" alt="" />
            <p style="right: 0" class="color-white">
              {{ item.name }}
            </p>
          </div>
        </swiper-slide>
      </swiper>
      <div class="FacSwiperIndex" >
          <div 
          v-for="(item, i) in devList"
                :class="{ TabIndex: devImgIndex == i }"
                :key="i"
                style="object-fit: cover;width: 15%;margin: 5px;"
                @click="handleSlideClick(i)"

          >
            <img
                class="h100 w100"
                style="object-fit: cover;"
                ondragstart="return false;"
                :src="item.path"
                alt=""
              />
          </div>

          </div>
      <!-- <swiper
        class="swiper swiperDevBtm"
        :options="swiperDevBtm"
        ref="swiperDevBtm"
      >
        <swiper-slide v-for="(item, i) in devList" :key="i">
          <img
            class="w100 h100"
            style="object-fit: cover"
            ondragstart="return false;"
            :src="item.path"
            alt=""
            @click="handleSlideClick(i)"
          />
        </swiper-slide>
      </swiper> -->
      <div class="swiper-button-prev" style="left: -15%; top: 45%">
        <img src="@/assets/btn/left2.png" alt="" />
      </div>
      <div class="swiper-button-next" style="right: -15%; top: 45%">
        <img src="@/assets/btn/right2.png" alt="" />
      </div>
    </div>
    <div class="w100 m-auto flex-row content-around dev-data">
      <div class="w40 flex-center flex-column flex-start dev-data-item">
        <img class="img-initial p-top-50 p-btm-50 devLogo" src="@/assets/208/btm-logo.png" alt="" />
        <p class="lh35 font18 regular">
          An established property developer in Singapore, Hoi Hup Realty Pte Ltd
          is committed to creating living spaces of the highest quality,
          comfort, functionality, and style. Its expertise has brought an array
          of residential, commercial and hospitality developments to completion.
          Over the years, it has also been recognised with many accolades
          including Best Lifestyle Developer at the PropertyGuru Asia Property
          Awards 2023, Top Sustainable Developer at the EdgeProp Singapore
          Excellence Awards 2023, and BCI Asia Awards’ Top Ten Developer from
          2021 to 2023.
        </p>
        <div @click="OpenUrl('https://www.hoihup.com/Home')"  class="b-radius-5 light p10 lt2 regular" style="border: 1px solid #4c4c4cc2;cursor: pointer;">VISIT WEBSITE</div>
      </div>
      <div class="w40 flex-center flex-column flex-start dev-data-item">
          <img class="img-initial p-top-50 p-btm-50 devLogo" src="@/assets/208/btm-logo1.png" alt="" />
        <p class="lh35 font18 regular">
          Sunway Developments Pte Ltd is a component of Sunway Property, which
          is the property division of Sunway Group, one of Southeast Asia’s
          leading conglomerates. As a Master Community Developer, Sunway
          Property has an established track record in managing and developing
          innovative and quality residential and non-residential properties in
          the region, including retail, leisure, healthcare, hospitality, as
          well as other commercial assets.
        </p>
        <div @click="OpenUrl('https://www.sunwayproperty.com')" class="b-radius-5 light p10 lt2 regular" style="border: 1px solid #4c4c4cc2;cursor: pointer;">VISIT WEBSITE</div>
      </div>
    </div>
    </div>
    <contant />
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import contant from "@/components/contant.vue";

export default {
  components: {
    Footer,
    contant,
  },
  data() {
    return {
      devImgIndex:0,
      devList:[
      {name: "TERRA HILL | ARTIST’S IMPRESSION",path: require("@/assets/developers/HH_Terra Hill_RGB_lr.png"),},
      {name: "THE CONTINUUM | ARTIST’S IMPRESSION",path: require("@/assets/developers/HH_Continuum_RGB_lr.jpg"),},
      {name: "KI RESIDENCES | ARTIST’S IMPRESSION",path: require("@/assets/developers/HH_Ki Residences_RGB_lr.jpg"),},
      {name: "PARC CENTRAL RESIDENCES",path: require("@/assets/developers/HH_Parc Central EC_RGB_lr.jpg"),},
      {name: "PARC CANBERRA",path: require("@/assets/developers/HH_Parc Canberra EC_RGB_lr.jpg"),},
      {name: "RIVERCOVE RESIDENCES",path: require("@/assets/developers/HH_Rivercove EC_RGB_lr.jpg"),},
      ],
      swiperDevBtm: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 6,
        // loopedSlides: 3, // looped slides should be the same
        // loop:true,
        touchRatio: 0.2,
        spaceBetween: 10,
        centeredSlides: true,
        // direction: 'vertical',
      },
      swiperDevTop: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slidesPerView: 1,
        // spaceBetween: 10,
        // centeredSlides: true,
        // loop:true,
        // autoplay: {
        //     delay: 3000, // 轮播间隔时间，单位为毫秒
        //     disableOnInteraction: false, // 用户操作后是否禁止自动轮播
        //   },
        on:{
          slideChange: (e)=> {
            this.devImgIndex = this.$refs.swiperDevTop.swiper.activeIndex;
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    handleSlideClick(index) {
      // 切换到指定索引的 slide
      console.log(index);
      this.devImgIndex = index;
      this.$refs.swiperDevTop.swiper.slideTo(index);
    },
    OpenUrl(url){
      window.open(url)
    },
    // handleSlideClick(index) {
    //   // 切换到指定索引的 slide
    //   console.log(index);
    //   this.$refs.swiperDevBtm.swiper.slideTo(index);
    // },
  },
  mounted() {
    this.$nextTick(() => {
      
      if (this.$refs.swiperDevTop && this.$refs.swiperDevTop.swiper) {
        console.log('Swiper initialized:', this.$refs.swiperDevTop.swiper);
        this.handleSlideClick(2)
      } else {
        console.error('Swiper not initialized');
      }
      // const top = this.$refs.swiperDevTop.swiper;
      // const bottom = this.$refs.swiperDevBtm.swiper;
      // top.controller.control = bottom;
      // bottom.controller.control = top;
      // this.$refs.swiperDevBtm.swiper.slideTo(2);

    });
  },
};
</script>

<style lang="less">
.developers {
  margin-top: -76px;
  background-image: url("~@/assets/facilities/facilities-bg.png");
  background-size: cover;
  .swiper-button-prev,
  .swiper-button-next {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    img {
      max-height: 2rem;
      max-width: 2rem;
    }
  }
  .FacSwiperIndex{
    display: flex;
    flex-flow: row;
    justify-content: center;
    // align-items: center;
    align-items: stretch;
    width: 100%;
    // height: 75px;
    .TabIndex{
      height: auto !important;
    }
    .TabIndex::before{
      // margin-bottom: -5px;
    }
  }
  .swiperDevBtm {
    height: 55px;
    padding-bottom: 15px;
    padding-top: 10px;
  }
  .swiperDevBtm .swiper-slide {
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
  .swiperDevBtm .swiper-slide-active {
    position: relative;
    opacity: 1;
  }
  .swiperDevBtm .swiper-slide-active::before {
    position: absolute;
    left: 0;
    bottom: -8px;
    content: "";
    background-color: #a98b59;
    width: 100%;
    height: 5px;
  }
  .swiperDevTop{
    height: 45vh;
  }
  .devLogo{
    height: 65px;
    width: 172px;
  }
}

@media (max-width: 900px) {
  .developers {
  margin-top: -76px;
    .content{
      padding-top: 95px;
    }

.dev-data{
  flex-direction:column !important;
  .dev-data-item{
    width: 100% !important;
  }
}
.swiperDevTop{
    height: 35vh !important;
  }
  .swiperDevBtm{
    height: 35px !important;
  }
  .FacSwiperIndex{
    height: 35px;
    .TabIndex{
      height: 35px !important;
    }
    .TabIndex::before{
      margin-bottom: -5px;
    }
  }
  .swiperDevBtm .swiper-slide-active::before{
    height: 3px !important;
  }
  .swiper-button-prev,
  .swiper-button-next{
    display: none !important;
  }

}
}



</style>










